import type { ChannelLocationStatusDto } from '@up2stay/up2promo-api-client';
import { ChannelSyncStatus } from '@up2stay/up2promo-api-client';

type ChannelSyncFields = Pick<
  ChannelLocationStatusDto,
  'locationId' | 'syncStatus' | 'lastSyncFailedAt' | 'lastSyncedAt'
>;

/** Same rule as the Status Board: a later failed sync than a successful one. */
export function isChannelLocationSyncFailed(
  channel: Omit<ChannelSyncFields, 'locationId'>,
): boolean {
  if (channel.syncStatus === ChannelSyncStatus.FAILED) {
    return true;
  }
  if (!channel.lastSyncFailedAt) {
    return false;
  }
  if (!channel.lastSyncedAt) {
    return true;
  }
  return (
    new Date(channel.lastSyncFailedAt).getTime() >
    new Date(channel.lastSyncedAt).getTime()
  );
}

export function locationIdsWithFailedSync(
  channels: readonly ChannelSyncFields[],
): Set<string> {
  const ids = new Set<string>();
  for (const channel of channels) {
    if (isChannelLocationSyncFailed(channel)) {
      ids.add(channel.locationId);
    }
  }
  return ids;
}
